<template>
  <div class="lawdetzz">
    <sub-title text="特邀律师" />
    <div class="zzlist between wrap">
      <div class="zzitem">
        <div><img src="../../../assets/laws/lawdetzzicon1.png" alt="" /></div>
        <div>法律咨询</div>
      </div>

      <div class="zzitem">
        <div><img src="../../../assets/laws/lawdetzzicon2.png" alt="" /></div>
        <div>律师费计算器</div>
      </div>

      <div class="zzitem">
        <div><img src="../../../assets/laws/lawdetzzicon3.png" alt="" /></div>
        <div>法律法规查询</div>
      </div>

      <div class="zzitem">
        <div><img src="../../../assets/laws/lawdetzzicon4.png" alt="" /></div>
        <div>找律师指南</div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.lawdetzz {
  padding: 22px 12px;
  .zzlist {
    padding: 1px 14px;
    font-size: 14px;
    color: #333333;
    .zzitem {
      width: 120px;
      height: 85px;
      background: #f8f8f8;
      text-align: center;
      padding: 15px 0;
      margin-top: 20px;
      cursor: pointer;
      &:hover{
          color: #0465EA;
      }
      img {
        margin-bottom: 12px;
        max-width: 31px;
        max-height: 28px;
      }
    }
  }
}
</style>